import React, { useState, useRef } from 'react';
import { makeStyles, Button, Grid } from '@material-ui/core';
import TextField from "@material-ui/core/TextField";
import MenuItem from '@material-ui/core/MenuItem';

import { rollDice } from '../utils/RollDice'

import DiceModal from './DiceModal'


const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    justifyContent: 'center',
    position: 'absolute',
    width: 200,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  diceDiv: {
    border: '2px solid white',
    padding: theme.spacing(1, 1, 1),
    color: 'white',
    height: 'auto'
  },
  text: {
    margin: 0
  },
  amountDice: {
    color: theme.palette.grey
  },
  button: {
    width: '100%',
    height: 'auto',
    textAlign: 'center'
}
}));



const DiceButton = ({ skillValue, skillName, dice }) => {
  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [diceValue, setDiceValue] = useState(-1);
  const [diceAmount, setDiceAmount] = useState(1)

  const modalRef = useRef();


  const handleOpen = () => {
    setDiceValue(-1)
    modalRef.current.handleOpen();
    setTimeout(function () {
      setDiceValue(rollDice(diceAmount, dice))
    }, 1500);
  };

  const onChangeAmount = (e) => {
    let fieldValue = e.target.value
    setDiceAmount(parseInt(fieldValue))
  }

  const modalBody = (
    <React.Fragment>
      <h2 id="simple-modal-title">{diceValue}</h2>
    </React.Fragment>
  )

  return (
    <React.Fragment>
      <Grid
        className={classes.diceDiv}
        container
        direction="column"
        justify="center"
        alignItems="center"
      >
        <Button className={classes.button} variant="contained" onClick={handleOpen}>
          {skillValue}
        </Button>
        <TextField
          className={classes.amountDice}
          helperText="Numero de dados"
          defaultValue={diceAmount}
          select
          onChange={(e) => { onChangeAmount(e) }}>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>
        <h1 className={classes.text}>{skillName}</h1>
      </Grid>

      <DiceModal
        ref={modalRef}
        diceValue={diceValue}
      >
        {modalBody}
      </DiceModal>
    </React.Fragment>
  );
}

export default DiceButton;